import type { DocumentId } from '../../types';
import type { OrganizationUserRoles } from '../../base';

type UserActions = {
  [P in OrganizationUserRoles as `atLeast${Capitalize<Lowercase<string & P>>}`]?: () => boolean;
};

export class MyUserViewModel implements UserActions {
  id: DocumentId;

  roles: OrganizationUserRoles[];

  orgID: string;

  email: string;

  userName?: string;

  atLeastAdmin() {
    return this.roles.some(r => ['admin'].includes(r));
  }

  atLeastMember() {
    return this.roles.some(r => ['member', 'admin'].includes(r));
  }

  atLeastGuest() {
    return this.roles.some(r => ['guest', 'member', 'admin'].includes(r));
  }
}
